import { FC } from 'react';

import { Box } from '@bonusly/design-system';

/**
 * Winter Background Tint
 * Adds a subtle blue-ish winter atmosphere with vignette effect
 */
export const BackgroundTint: FC = () => {
	return (
		<>
			<Box
				position="fixed"
				top={0}
				left={0}
				width="100vw"
				height="100vh"
				pointerEvents="none"
				zIndex={-1}
				background="radial-gradient(ellipse at center, transparent 0%, rgba(200, 230, 255, 0.03) 100%)"
			/>
			<style>
				{`
					@keyframes winterSparkle {
						0%, 100% {
							opacity: 0.5;
						}
						50% {
							opacity: 0.8;
						}
					}

					body::before {
						content: '';
						position: fixed;
						top: 0;
						left: 0;
						width: 100vw;
						height: 100vh;
						pointer-events: none;
						z-index: 9998;
						background-image: 
							radial-gradient(ellipse at 20% 30%, rgba(135, 206, 235, 0.08), transparent 40%),
							radial-gradient(ellipse at 80% 70%, rgba(176, 224, 230, 0.06), transparent 40%);
						animation: winterSparkle 4s ease-in-out infinite;
					}
				`}
			</style>
		</>
	);
};
